<template>
  <div class="advice5-wrap">
    <main class="screen" role="main">

      <div class="header">
        <button
          type="button"
          class="back-button"
          @click="goBack"
          aria-label="Zurück"
        >←</button>
      </div>

      <span class="badge">Wissen</span>
      <h1 class="title">Schweizer Ernährungsbasics</h1>
      <p class="subtitle">
        Die Grundlagen einfach erklärt. Gut, wenn du Begriffe oder Empfehlungen
        nachschlagen möchtest.
      </p>

      <button type="button" class="featured-card">
        <span class="featured-emoji" aria-hidden="true">🍽️</span>
        <span class="featured-content">
          <span class="featured-eyebrow">Empfohlen für dich</span>
          <span class="featured-title">Was ist eine Portion?</span>
          <span class="featured-detail">Die wichtigsten Mengenangaben auf einen Blick.</span>
        </span>
        <span class="featured-arrow" aria-hidden="true">→</span>
      </button>

      <h2 class="section-heading">Themen</h2>

      <div class="topic-grid">
        <button
          v-for="t in topics"
          :key="t.id"
          type="button"
          class="topic-card"
        >
          <div class="topic-emoji" aria-hidden="true">{{ t.emoji }}</div>
          <p class="topic-name">{{ t.name }}</p>
          <p class="topic-detail">{{ t.detail }}</p>
        </button>
      </div>

      <h2 class="section-heading">Kurz erklärt</h2>

      <div class="article-list">
        <button
          v-for="a in articles"
          :key="a.id"
          type="button"
          class="article-item"
        >
          <span class="article-emoji" aria-hidden="true">📖</span>
          <span class="article-content">
            <span class="article-title">{{ a.title }}</span>
            <span class="article-meta">{{ a.minutes }} Min. Lesezeit</span>
          </span>
          <span class="article-arrow" aria-hidden="true">›</span>
        </button>
      </div>

      <p class="placeholder-note">
        Beispielinhalte. Die finalen Texte werden vom Ernährungsteam erstellt,
        gestützt auf SGE-Materialien.
      </p>

    </main>
  </div>
</template>

<script>
export default {
  name: 'Advice5',
  data() {
    return {
      topics: [
        { id: 'pyramide', emoji: '🔺', name: 'Schweizer Lebensmittelpyramide', detail: 'Aufbau und Logik' },
        { id: 'sge', emoji: '⚖️', name: 'SGE-Empfehlungen', detail: 'Tagesrichtwerte im Überblick' },
        { id: 'trinken', emoji: '💧', name: 'Trinken', detail: 'Wie viel und was zählt' },
        { id: 'huelsen', emoji: '🌱', name: 'Pflanzliche Proteine', detail: 'Hülsenfrüchte und mehr' },
        { id: 'vollkorn', emoji: '🌾', name: 'Vollkorn vs. Weissmehl', detail: 'Worin liegt der Unterschied' },
        { id: 'milch', emoji: '🥛', name: 'Milch und Alternativen', detail: 'Tierisch vs. pflanzlich' },
      ],
      articles: [
        { id: 'huelsen-was', title: 'Was sind Hülsenfrüchte?', minutes: 2 },
        { id: 'verarbeitet', title: 'Verarbeitete Lebensmittel erkennen', minutes: 3 },
        { id: 'saisonal', title: 'Saisonal essen in der Schweiz', minutes: 4 },
      ],
    };
  },
  methods: {
    goBack() { this.$router.back(); },
  },
};
</script>

<style scoped>
.advice5-wrap {
  --color-bg-page: #f5f4ef;
  --color-bg-card: #ffffff;
  --color-bg-muted: #f1efe8;
  --color-text-primary: #2c2c2a;
  --color-text-secondary: #5f5e5a;
  --color-text-tertiary: #888780;
  --color-border: rgba(0, 0, 0, 0.15);
  --color-accent: #534AB7;
  --color-accent-light: #EEEDFE;
  --radius-md: 8px;
  --radius-lg: 12px;
  --font-sans: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;

  background: var(--color-bg-page);
  font-family: var(--font-sans);
  color: var(--color-text-primary);
  line-height: 1.5;
  min-height: 100%;
  padding: 1.25rem;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  box-sizing: border-box;
}

.advice5-wrap *,
.advice5-wrap *::before,
.advice5-wrap *::after {
  box-sizing: border-box;
}

.screen {
  width: 100%;
  max-width: 420px;
  background: var(--color-bg-card);
  border-radius: var(--radius-lg);
  border: 0.5px solid var(--color-border);
  padding: 1.5rem 1.25rem;
  min-height: 600px;
}

.header {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.back-button {
  background: transparent;
  border: none;
  padding: 4px 8px;
  cursor: pointer;
  font-size: 20px;
  color: var(--color-text-secondary);
  line-height: 1;
}

.badge {
  display: inline-block;
  background: var(--color-accent-light);
  color: var(--color-accent);
  font-size: 12px;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: var(--radius-md);
  margin-bottom: 1rem;
  letter-spacing: 0.02em;
}

.title {
  font-size: 24px;
  font-weight: 500;
  margin: 0 0 8px;
  line-height: 1.25;
}

.subtitle {
  font-size: 14px;
  color: var(--color-text-secondary);
  margin: 0 0 1.5rem;
  line-height: 1.6;
}

.featured-card {
  width: 100%;
  background: var(--color-accent-light);
  border-radius: var(--radius-lg);
  padding: 1.25rem;
  margin-bottom: 1.5rem;
  cursor: pointer;
  border: 0.5px solid var(--color-accent);
  display: flex;
  gap: 14px;
  align-items: center;
  font-family: inherit;
  text-align: left;
}

.featured-emoji {
  flex-shrink: 0;
  font-size: 40px;
  line-height: 1;
}

.featured-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.featured-eyebrow {
  font-size: 11px;
  color: var(--color-accent);
  margin: 0 0 4px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  font-weight: 500;
}

.featured-title {
  font-size: 16px;
  font-weight: 500;
  margin: 0 0 4px;
  color: var(--color-text-primary);
}

.featured-detail {
  font-size: 13px;
  color: var(--color-text-secondary);
  margin: 0;
  line-height: 1.4;
}

.featured-arrow {
  color: var(--color-accent);
  font-size: 18px;
}

.section-heading {
  font-size: 14px;
  font-weight: 500;
  color: var(--color-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin: 0 0 12px;
}

.topic-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 1.5rem;
}

.topic-card {
  border: 0.5px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: 14px 12px;
  background: var(--color-bg-card);
  cursor: pointer;
  transition: background 0.15s;
  font-family: inherit;
  text-align: left;
}

.topic-card:hover {
  background: var(--color-bg-muted);
}

.topic-emoji {
  font-size: 28px;
  line-height: 1;
  margin-bottom: 8px;
}

.topic-name {
  font-size: 13px;
  font-weight: 500;
  margin: 0 0 4px;
  color: var(--color-text-primary);
  line-height: 1.3;
}

.topic-detail {
  font-size: 11px;
  color: var(--color-text-tertiary);
  margin: 0;
  line-height: 1.4;
}

.article-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 1.5rem;
}

.article-item {
  display: flex;
  gap: 12px;
  padding: 12px 14px;
  border: 0.5px solid var(--color-border);
  border-radius: var(--radius-md);
  background: var(--color-bg-card);
  cursor: pointer;
  align-items: center;
  transition: background 0.15s;
  font-family: inherit;
  text-align: left;
  width: 100%;
}

.article-item:hover {
  background: var(--color-bg-muted);
}

.article-emoji {
  flex-shrink: 0;
  font-size: 22px;
  line-height: 1;
}

.article-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.article-title {
  font-size: 14px;
  font-weight: 500;
  margin: 0 0 2px;
  color: var(--color-text-primary);
  line-height: 1.3;
}

.article-meta {
  font-size: 12px;
  color: var(--color-text-tertiary);
  margin: 0;
}

.article-arrow {
  color: var(--color-text-tertiary);
  font-size: 16px;
}

.placeholder-note {
  font-size: 11px;
  color: var(--color-text-tertiary);
  text-align: center;
  margin-top: 1rem;
  font-style: italic;
}
</style>
